import { Injectable, signal } from '@angular/core';
import {
  SEU_CALC_OUTPUT_NAVBAR_MIN_HEIGHT,
  SEU_CALC_OUTPUT_SNAP_MIN,
} from '@seu-types';

@Injectable({
  providedIn: 'root',
})
export class CalculationOutputService {
  public readonly calculationOutputBarHeight = signal(
    SEU_CALC_OUTPUT_NAVBAR_MIN_HEIGHT
  );

  public readonly navbarPreviewHeight = signal(0);

  public openNavigationFlap(): void {
    this.updateBarHeight(this.navbarPreviewHeight());
  }

  public updateBarHeight(height: number): void {
    this.calculationOutputBarHeight.update(() => {
      if (height < SEU_CALC_OUTPUT_SNAP_MIN) {
        return SEU_CALC_OUTPUT_NAVBAR_MIN_HEIGHT;
      }
      if (
        height >
        document.documentElement.clientHeight - SEU_CALC_OUTPUT_SNAP_MIN
      ) {
        return document.documentElement.clientHeight;
      }
      return height;
    });
  }
  constructor() {}
}
